import { Action } from 'infra/types'
import {
  FilterDrawerType,
  IBrandProductMapping,
  IBrandReportSummary,
  IBrandSaleSummary,
  IBrandSummaryDateFilter,
  IBrandSummaryState,
  IFetchBrandReportPayload,
  IFetchBrandSummaryActionPayload,
  SelectedDataKey
} from 'state/new-summary/brand/brand.types'

export const BrandSummaryActions = {
  RESET_PAGINATION_DATA: 'brandSummary/RESET_PAGINATION_DATA',
  SET_PAGINATION_DATA: 'brandSummary/SET_PAGINATION_DATA',
  SET_DOWNLOAD_FILTERED_VIEW: 'brandSummary/SET_DOWNLOAD_FILTERED_DATA',
  SET_FILTER_PAGINATION_DATA: 'brandSummary/SET_FILTER_PAGINATION_DATA',
  SET_FILTER_DATA_SUCCESS: 'brandSummary/SET_FILTER_DATA_SUCCESS',
  SET_FILTER_DRAWER_TYPE: 'brandSummary/SET_FILTER_DRAWER_TYPE',
  SET_DRAWER: 'brandSummary/SET_DRAWER',
  SET_LOADER: 'brandSummary/SET_LOADER',
  FETCH_BRAND_SUMMARY_DATA: 'brandSummary/FETCH_BRAND_SUMMARY_DATA',
  FETCH_BRAND_SUMMARY_DATA_SUCCESS: 'brandSummary/FETCH_BRAND_SUMMARY_DATA_SUCCESS',
  SET_BRAND_SALE_ACTIVE_FILTER: 'brandSummary/SET_BRAND_SALE_ACTIVE_FILTER',
  SET_OVERALL_BRAND_SUMMARY: 'brandSummary/SET_OVERALL_BRAND_SUMMARY',
  FETCH_BRAND_REPORT: 'brandSummary/FETCH_BRAND_REPORT',
  FETCH_BRAND_REPORT_SUCCESS: 'brandSummary/FETCH_BRAND_REPORT_SUCCESS',
  DOWNLOAD_BRAND_REPORT: 'brandSummary/DOWNLOAD_BRAND_REPORT',
  FETCH_BRAND_PRODUCT_MAPPING: 'brand/FETCH_BRAND_PRODUCT_MAPPING',
  SET_BRAND_PRODUCT_MAPPING: 'brand/SET_BRAND_PRODUCT_MAPPING',
  UPLOAD_BRAND_PRODUCT_MAPPING: 'brand/UPLOAD_BRAND_PRODUCT_MAPPING'
}

export const resetPaginationAction = (): Action<null> => ({
  type: BrandSummaryActions.RESET_PAGINATION_DATA,
  payload: null
})

export const fetchBrandProductMapping = (): Action<null> => ({
  type: BrandSummaryActions.FETCH_BRAND_PRODUCT_MAPPING,
  payload: null
})

export const setBrandProductMapping = (payload: {
  brandProductMapping: IBrandProductMapping['products']
  allProductCode: Set<string>
  allProductName: Set<string>
  productCodeToProductIdMapper: Map<string, string>
  productNameToProductIdMapper: Map<string, string[]>
}): Action<{
  brandProductMapping: IBrandProductMapping['products']
  allProductCode: Set<string>
  allProductName: Set<string>
  productCodeToProductIdMapper: Map<string, string>
  productNameToProductIdMapper: Map<string, string[]>
}> => ({
  type: BrandSummaryActions.SET_BRAND_PRODUCT_MAPPING,
  payload
})

export const uploadProductMapping = (payload: {
  formData: FormData
}): Action<{ formData: FormData }> => {
  return {
    type: BrandSummaryActions.UPLOAD_BRAND_PRODUCT_MAPPING,
    payload
  }
}

export const setLoaderAction = (payload: {
  id: keyof IBrandSummaryState['loaders']
  value: boolean
}): Action<{ id: string; value: boolean }> => ({
  type: BrandSummaryActions.SET_LOADER,
  payload
})

export const setDownloadFilteredView = (payload: boolean): Action<boolean> => ({
  type: BrandSummaryActions.SET_DOWNLOAD_FILTERED_VIEW,
  payload
})

export const setDrawerAction = (payload: {
  id: string
  value: boolean
}): Action<{ id: string; value: boolean }> => ({
  type: BrandSummaryActions.SET_DRAWER,
  payload
})

export const setFilterData = (payload: {
  selectedDataKey: SelectedDataKey | ''
  selectedDataValues: string[]
  paginationData?: {
    page: number
    pageSize: number
    totalCount: number
  }
}): Action<{
  selectedDataKey: SelectedDataKey | ''
  selectedDataValues: string[]
  paginationData?: {
    page: number
    pageSize: number
    totalCount: number
  }
}> => ({
  type: BrandSummaryActions.SET_FILTER_PAGINATION_DATA,
  payload
})

export const setFilterDataSuccess = (payload: {
  selectedDataKey: SelectedDataKey
  selectedDataValues: string[]
}): Action<{ selectedDataKey: SelectedDataKey; selectedDataValues: string[] }> => ({
  type: BrandSummaryActions.SET_FILTER_DATA_SUCCESS,
  payload
})

export const setFilterDrawerType = (payload: {
  drawerType: FilterDrawerType
  dataList: string[]
  selectedDataKey?: SelectedDataKey
  selectedDataValues?: string[]
}): Action<{
  drawerType: FilterDrawerType
  dataList: string[]
  selectedDataKey?: SelectedDataKey
  selectedDataValues?: string[]
}> => ({
  type: BrandSummaryActions.SET_FILTER_DRAWER_TYPE,
  payload
})

export const fetchBrandSummaryDataAction = (
  payload: IFetchBrandSummaryActionPayload
): Action<IFetchBrandSummaryActionPayload> => ({
  type: BrandSummaryActions.FETCH_BRAND_SUMMARY_DATA,
  payload
})

export const fetchBrandSummaryDataSuccessAction = (
  payload: IBrandSaleSummary[]
): Action<IBrandSaleSummary[]> => ({
  type: BrandSummaryActions.FETCH_BRAND_SUMMARY_DATA_SUCCESS,
  payload
})

export const setOverallBrandSummaryAction = (
  payload: IBrandSaleSummary
): Action<IBrandSaleSummary> => ({
  type: BrandSummaryActions.SET_OVERALL_BRAND_SUMMARY,
  payload
})

export const setBrandSaleActiveFilterAction = (
  payload: IBrandSummaryDateFilter
): Action<IBrandSummaryDateFilter> => ({
  type: BrandSummaryActions.SET_BRAND_SALE_ACTIVE_FILTER,
  payload
})

export const setPaginationData = (payload: {
  page: number
  pageSize: number
  totalCount: number
}): Action<{ page: number; pageSize: number; totalCount: number }> => ({
  type: BrandSummaryActions.SET_PAGINATION_DATA,
  payload
})

export const fetchBrandReportAction = (
  payload: IFetchBrandReportPayload
): Action<IFetchBrandReportPayload> => ({
  type: BrandSummaryActions.FETCH_BRAND_REPORT,
  payload
})

export const fetchBrandReportSuccessAction = (
  payload: IBrandReportSummary[]
): Action<IBrandReportSummary[]> => ({
  type: BrandSummaryActions.FETCH_BRAND_REPORT_SUCCESS,
  payload
})

export const downloadBrandReportAction = (
  payload: IFetchBrandReportPayload
): Action<IFetchBrandReportPayload> => ({
  type: BrandSummaryActions.DOWNLOAD_BRAND_REPORT,
  payload
})
